module.exports = __webpack_public_path__ + "static/mesetas-bde474c72f3b44eaeb35f8923e82ffc2.jpg";